import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "actor-warp"
};
const _hoisted_2 = {
  class: "table-warp cms-card-block"
};
import { editCmsOperatorApi, getCmsRoleApi, getCmsUserListApi, getOperatorNameListApi } from '@/api/authority';
import RelevanceInfoDialog from '@/components/RelevanceInfoDialog/index.vue';
import { elMessage } from '@/utils';
import { clearData, getItemByProp } from '@/utils/tools';
import { usePageConfig, useTableOptions } from '@/utils/useComponentConfig';
import { formValidator } from '@/utils/validate';
import { nextTick, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useBrandsByUser } from '@/utils/cacheData';
import { getCurrentTime } from '@/utils/timeFormat';
import { checkAgentApi, getRelationAgentApi, getMainBrandOptionsApi, getCustomerSubAgentApi, addRelationAgentApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const formRef = ref(null);
    const relevanceInfoDialog = reactive({
      visible: false
    });
    const infoTreeData = ref([]);
    const searchConfig = reactive({
      formList: [{
        label: '角色',
        prop: 'roleId',
        widgetType: 'Select',
        filterable: true,
        labelKey: 'name',
        valueKey: 'id',
        change: () => {
          getCmsRoleList();
        }
      }, {
        label: '关键字筛选',
        prop: 'name',
        widgetType: 'input',
        placeholder: '请输入关键字',
        maxlength: 50
      }],
      formData: {
        roleId: '',
        name: ''
      },
      handleSearch: () => {
        const item = getItemByProp(searchConfig.formList, 'roleId');

        if (item.list.length) {
          getCmsRoleList();
        }

        return;
      },
      handleReset: () => {
        tableConfig.paginationConfig.page = 1;
        const item = getItemByProp(searchConfig.formList, 'roleId');

        if (item.list.length) {
          searchConfig.formData.roleId = item.list[0].id;
          getCmsRoleList();
        }

        return;
      }
    });

    const getOptions = list => {
      let newList = [];
      list.forEach((item, index) => {
        newList.push({
          value: item.id,
          label: item.name,
          children: item.children != null && item.children.length > 0 ? getOptions(item.children) : null
        });
      });
      return newList;
    };

    const tableConfig = reactive({
      data: [],
      isCardBlock: false,
      loading: false,
      paginationConfig: usePageConfig(),
      isShowHeader: true,
      options: useTableOptions(),
      listName: '系统用户权限',
      columnList: [{
        label: '用户名_c',
        prop: 'name'
      }, {
        label: '角色',
        prop: 'roleName'
      }, {
        label: '创建时间',
        prop: 'createTime',
        width: 170,
        formatter: val => val && getCurrentTime(val)
      }, {
        label: '创建人',
        prop: 'creater'
      }, {
        label: '状态',
        prop: 'state',
        formatter: val => {
          if (val !== null && val !== undefined) {
            return `<span style='${val == 0 ? '' : 'color:green;'}'>${val == 0 ? t('已停用') : t('启用中')}<span>`;
          }
        }
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        buttonsList: [{
          label: '查看',
          func: async row => {
            relevanceInfoDialog.visible = true;

            try {
              const res = await checkAgentApi({
                userId: row.id
              }); // console.log('checkAgentApi', res);

              if (res.code == '0') {
                infoTreeData.value = res.data ? [res.data] : [];
              }
            } catch (error) {
              console.log(error);
            } // console.log('infoTreeData.value', infoTreeData.value);

          }
        }, {
          label: '关联权限',
          func: async row => {
            clearData(actionForm.formData);
            actionForm.dialogConfig.title = '关联权限';
            currentTableColumnUserId.value = row.id;
            actionForm.action = 'default';
            actionForm.visible = true;
            actionForm.loading = true;

            try {
              const res = await getRelationAgentApi({
                userId: row.id
              }); // console.log('getRelationAgentApi', res)

              if (res.code == '0') {
                actionForm.formData.cid = res.data.cid;
                await getMainBrandList(res.data.cid);
                let mainBrandSelectList = [];
                let subBrandSelectList = [];

                if (res.data.agentList.length) {
                  res.data.agentList.forEach(item => {
                    mainBrandSelectList.push(item.mainAgentId);
                    subBrandSelectList.push(item.subAgentId);
                  });
                }

                actionForm.formData.mainBrand = Array.from(new Set(mainBrandSelectList));
                await checkSubAgent(Array.from(new Set(mainBrandSelectList)));
                actionForm.formData.subBrand = Array.from(new Set(subBrandSelectList));
                actionForm.loading = false;
              } else {
                actionForm.loading = false;
              }
            } catch (error) {
              actionForm.loading = false;
            }
          }
        }, {
          label: '运营商',
          func: async row => {
            clearData(actionForm.formData);
            actionForm.dialogConfig.title = '运营商';
            actionForm.action = 'operator';
            actionForm.visible = true;
            actionForm.loading = true;
            actionForm.formData.userId = row.id;
            actionForm.formData.cpspId = row.operatorId;

            try {
              const res = await getOperatorNameListApi();

              if (res.code == '0') {
                let item = getItemByProp(actionForm.formList, 'cpspId');
                item.list = getOptions(res.data);
                actionForm.loading = false;
              } else {
                actionForm.loading = false;
              }
            } catch (error) {
              actionForm.loading = false;
            }

            ;
          }
        }]
      }]
    }); // 校验主品牌

    const validatorMainBrand = (rule, value, callback) => {
      if (actionForm.formData.cid === '') {
        if (!value.length) {
          return callback(new Error(t('请先选择品牌')));
        } else {
          callback();
        }
      } else {
        const item = getItemByProp(actionForm.formList, 'mainBrand');

        if (item.list.length) {
          if (!value.length) {
            return callback(new Error(t('请选择主品牌')));
          } else {
            callback();
          }
        } else {
          return callback(new Error(t('请先创建主品牌')));
        }
      }
    }; // 校验子品牌


    const validatorSubBrand = (rule, value, callback) => {
      if (actionForm.formData.cid === '') {
        if (!value.length) {
          return callback(new Error(t('请先选择主品牌')));
        } else {
          callback();
        }
      } else {
        if (!actionForm.formData.mainBrand.length) {
          if (!value.length) {
            return callback(new Error(t('请先选择主品牌')));
          } else {
            callback();
          }
        } else {
          const item = getItemByProp(actionForm.formList, 'subBrand'); // console.log('item.list.length', item.list.length);

          if (item.list.length) {
            if (!value.length) {
              return callback(new Error(t('请选择子品牌')));
            } else {
              callback();
            }
          } else {
            // console.log('notSubBrandId', notSubBrandId.value);
            if (notSubBrandId.value.length) {
              let errTextArr = [];
              let mainBrandItem = getItemByProp(actionForm.formList, 'mainBrand');
              mainBrandItem.list.forEach(mainItem => {
                notSubBrandId.value.forEach(notSubItem => {
                  if (notSubItem == mainItem.id) {
                    errTextArr.push(mainItem.name);
                  }
                });
              }); // console.log(errTextArr.join(','));

              return callback(new Error(t('下列主品牌先创建子品牌', {
                text: errTextArr.join(',')
              })));
            }

            return callback(new Error(t('请先创建子品牌')));
          }
        }
      }
    };

    const actionForm = reactive({
      visible: false,
      loading: false,
      action: 'default',
      formList: [[{
        label: '品牌',
        prop: 'cid',
        widgetType: 'Select',
        list: [],
        required: true,
        filterable: true,
        placeholder: '请选择品牌',
        labelKey: 'prefixName',
        valueKey: 'cid',
        onChange: async val => {
          formRef.value.mForm.clearValidate('subBrand');
          await getMainBrandList(val);
          notSubBrandId.value = [];
          actionForm.formData.mainBrand = [];
          actionForm.formData.subBrand = [];
          formRef.value.mForm.validateField('mainBrand');
        },
        controller: () => {
          return actionForm.action == 'default';
        }
      }], [{
        label: '主品牌',
        prop: 'mainBrand',
        widgetType: 'Select',
        labelKey: 'name',
        valueKey: 'id',
        multiple: true,
        list: [],
        required: true,
        onChange: async val => {
          actionForm.loading = true;

          try {
            await checkSubAgent(val);
            let subBrandList = getItemByProp(actionForm.formList, 'subBrand').list;
            let newSubBrandSelectList = [];
            subBrandList.forEach(item => {
              actionForm.formData.subBrand.forEach(selectItem => {
                if (selectItem == item.subAgentId) {
                  newSubBrandSelectList.push(selectItem);
                }
              });
            });
            actionForm.formData.subBrand = newSubBrandSelectList;
          } catch (error) {}

          actionForm.loading = false;
        },
        controller: () => {
          return actionForm.action == 'default';
        }
      }], [{
        label: '子品牌',
        prop: 'subBrand',
        widgetType: 'Select',
        labelKey: 'subAgentName',
        valueKey: 'subAgentId',
        multiple: true,
        list: [],
        required: true,
        onChange: val => {},
        controller: () => {
          return actionForm.action == 'default';
        }
      }], [{
        label: '运营商',
        prop: 'cpspId',
        widgetType: 'treeSelect',
        list: [],
        clearable: true,
        filterable: true,
        required: true,
        controller: () => {
          return actionForm.action == 'operator';
        },
        change: val => {
          console.log(val);
          console.log(actionForm.formData);
        } // props: {
        //     label: 'name',
        //     children: 'children',
        //     value: 'id',
        // }

      }]],
      formData: {
        cid: '',
        mainBrand: [],
        subBrand: [],
        cpspId: 0,
        userId: ''
      },
      dialogConfig: {
        title: '关联权限',
        destroyOnClose: true
      },
      rules: {
        cid: [{
          required: true,
          message: t('请选择品牌'),
          trigger: 'change'
        }],
        mainBrand: [{
          required: true,
          validator: validatorMainBrand,
          trigger: 'change'
        }],
        subBrand: [{
          required: true,
          validator: validatorSubBrand,
          trigger: 'change'
        }],
        cpspId: [{
          required: true,
          message: t('请选择运营商'),
          trigger: 'change'
        }]
      },
      confirm: done => {
        formValidator(formRef.value.mForm).then(() => {
          if (actionForm.action == 'default') {
            addRelationAgent(done);
          } else if (actionForm.action == 'operator') {
            editCmsOperator(done);
          }
        }, () => done());
      }
    });
    const currentTableColumnUserId = ref(null); // 关联权限

    const addRelationAgent = async done => {
      try {
        let relationAgentList = [];
        let subBrandList = getItemByProp(actionForm.formList, 'subBrand').list;
        let subBrandSelectArr = actionForm.formData.subBrand;
        subBrandList.forEach(listItem => {
          subBrandSelectArr.forEach(selectItem => {
            if (selectItem == listItem.subAgentId) {
              relationAgentList.push({
                subAgentId: listItem.subAgentId,
                mainAgentId: listItem.mainAgentId,
                subAgentName: listItem.subAgentName
              });
            }
          });
        });
        let params = {
          cid: actionForm.formData.cid,
          agentList: relationAgentList,
          userId: currentTableColumnUserId.value
        }; // console.log('addRelationAgent', params);

        const res = await addRelationAgentApi(params);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          actionForm.visible = false;
          getCmsRoleList();
        }

        done();
      } catch (error) {
        done();
      }
    }; // 关联运营商


    const editCmsOperator = async done => {
      try {
        let params = {
          operatorId: actionForm.formData.cpspId,
          userId: actionForm.formData.userId
        };
        const res = await editCmsOperatorApi(params);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          actionForm.visible = false;
          getCmsRoleList();
        }

        done();
      } catch (error) {
        done();
      }
    }; // 获取品牌下的主品牌列表


    const getMainBrandList = async id => {
      try {
        let item = getItemByProp(actionForm.formList, 'mainBrand');
        const res = await getMainBrandOptionsApi(id); // console.log('getRelationMainAgentApi', res);

        if (res.code == '0') {
          item.list = res.data;
        }
      } catch (error) {}
    };

    const notSubBrandId = ref([]); // 检查是否有子品牌

    const checkSubAgent = async mainAgentIdArr => {
      let item = getItemByProp(actionForm.formList, 'subBrand');
      notSubBrandId.value = [];
      item.list = [];

      if (mainAgentIdArr.length) {
        // let time = 0
        // for (let i = 0; i < mainAgentIdArr.length; i++) {
        //     const res = await checkSubAgentApi({ mainAgentId: mainAgentIdArr[i] }) as ResType
        //     if (res.code === '0') {
        //         if (res.data) {
        //             time = time + 1
        //         } else {
        //             notSubBrandId.value.push(mainAgentIdArr[i])
        //         }
        //     }
        // }
        // if (time == mainAgentIdArr.length) {
        //     await getSubBrandList(mainAgentIdArr)
        // } else {
        //     item.list = []
        // }
        await getSubBrandList(mainAgentIdArr);
        formRef.value.mForm.validateField('subBrand');
      } else {
        formRef.value.mForm.validateField('subBrand');
      }
    }; // 获取主品牌下的子品牌列表


    const getSubBrandList = async ids => {
      let item = getItemByProp(actionForm.formList, 'subBrand');
      const res = await getCustomerSubAgentApi(ids); // console.log('getRelationSubAgentApi', res);

      if (res.code == '0') {
        let mainBrandSelectArr = actionForm.formData.mainBrand;
        let subBrandList = [];
        res.data.forEach(subItem => {
          subBrandList.push(subItem.mainAgentId);
        });
        subBrandList = Array.from(new Set(subBrandList));
        mainBrandSelectArr.forEach(item => {
          if (!subBrandList.includes(item)) {
            notSubBrandId.value.push(item);
          }
        });

        if (!notSubBrandId.value.length) {
          nextTick(() => {
            item.list = res.data;
          });
        } // console.log('notSubBrandId', notSubBrandId);

      }
    }; // 获取表格列表


    const getCmsRoleList = async () => {
      tableConfig.loading = true;

      try {
        const res = await getCmsUserListApi({ ...searchConfig.formData,
          page: tableConfig.paginationConfig.page,
          limit: tableConfig.paginationConfig.limit
        }); // console.log(res);

        if (res.code === '0') {
          tableConfig.data = res.data;
          tableConfig.paginationConfig.total = res.total;
        }
      } catch (error) {}

      tableConfig.loading = false;
    }; // 获取搜索栏角色下拉数据


    const getCmsRoleSelectList = async () => {
      try {
        let item = getItemByProp(searchConfig.formList, 'roleId');
        const res = await getCmsRoleApi();

        if (res.code === '0') {
          item.list = res.data; // 如果有角色下拉列表数据就设置默认值, 并且请求获取列表

          if (res.data.length) {
            searchConfig.formData.roleId = res.data[0].id;
            getCmsRoleList();
          }
        }
      } catch (error) {}
    }; // 获取品牌选项数据


    const getBrands = async () => {
      try {
        const brands = await useBrandsByUser();
        let brandItem = getItemByProp(actionForm.formList, 'cid');
        if (brandItem) brandItem.list = brands;
      } catch (error) {
        console.log(error);
      }
    };

    const setOptionsBtnColumnWidth = width => {
      const findItem = tableConfig.columnList.find(item => item.label == '操作');
      findItem ? findItem.width = width : '';
    };

    watch(() => actionForm.visible, val => {
      if (val) {
        let mainBrandItem = getItemByProp(actionForm.formList, 'mainBrand');
        let subBrandItem = getItemByProp(actionForm.formList, 'subBrand');
        mainBrandItem.list = [];
        subBrandItem.list = [];
      }
    });
    onMounted(() => {
      getBrands();
      getCmsRoleSelectList();
    });
    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_FormTable = _resolveComponent("FormTable");

      const _component_m_dialog = _resolveComponent("m-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: searchConfig.handleSearch,
        onReset: searchConfig.handleReset
      }, null, 8, ["form-list", "form-data", "onSearch", "onReset"]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_common_table, {
        "option-column-list": tableConfig.columnList,
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref: "tableRef",
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        options: tableConfig.options,
        render: getCmsRoleList
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": tableConfig.columnList
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["option-column-list", "table-config", "pagination-config", "options"])])), [[_directive_loading, tableConfig.loading]]), _createVNode(_component_m_dialog, {
        autoLoading: "",
        modelValue: actionForm.visible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => actionForm.visible = $event),
        "dialog-config": actionForm.dialogConfig,
        nativeConfig: {
          width: '40%',
          closeOnClickModal: false
        },
        onOnConfirm: actionForm.confirm
      }, {
        default: _withCtx(() => [_withDirectives(_createVNode(_component_FormTable, {
          ref_key: "formRef",
          ref: formRef,
          "form-list": actionForm.formList,
          "form-data": actionForm.formData,
          rules: actionForm.rules
        }, null, 8, ["form-list", "form-data", "rules"]), [[_directive_loading, actionForm.loading]])]),
        _: 1
      }, 8, ["modelValue", "dialog-config", "onOnConfirm"]), _createVNode(RelevanceInfoDialog, {
        modelValue: relevanceInfoDialog.visible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => relevanceInfoDialog.visible = $event),
        "dialog-title": "关联权限",
        "info-tree-data": infoTreeData.value
      }, null, 8, ["modelValue", "info-tree-data"])]);
    };
  }

});